import type { PicklistEntry } from "../api/getTestCompanySchema";

/**
 * The selectable entries of a Salesforce picklist: active only, sorted by
 * label. SF returns entries in admin-defined order, which drifts as values
 * are appended. `preserveOrder` keeps that order for lists whose order is
 * meaningful, like the growth-level ladder (Build → Scale).
 */
export function activePicklistOptions(
  options: PicklistEntry[] | undefined,
  { preserveOrder = false }: { preserveOrder?: boolean } = {},
): PicklistEntry[] {
  const active = (options ?? []).filter((o) => o.active);
  if (preserveOrder) return active;

  return [...active].sort((a, b) =>
    a.label.localeCompare(b.label, "en", { sensitivity: "base" }),
  );
}
